"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDateToDayMonthString = transformDateToDayMonthString;
function transformDateToDayMonthString(date) {
    const dateToString = new Date(date);
    const month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][dateToString.getUTCMonth()];
    const day = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][dateToString.getUTCDay()];
    const dayNumber = dateToString.getUTCDate().toString();
    return `${day} ${dayNumber} ${month}`;
}
//# sourceMappingURL=transformDateToDayMonthString.js.map